<nb-tabset>
    <nb-tab tabTitle="Usuarios - Clientes" tabIcon="people-outline" responsive>
        <app-sub-usuarios></app-sub-usuarios>
    </nb-tab>
</nb-tabset>